import React from 'react';
import PropTypes from 'prop-types';
import _filter from 'lodash/filter';
import _includes from 'lodash/includes';
// HOCs
import { connect } from 'react-redux';
// Models
import mDeviceModel from 'models/deviceModel';
// Custom
import { deviceModelsShape } from 'constants/PropTypesShapes';
import ResourceSelectFieldFilter from 'components/filters/ResourceSelectFieldFilter';

const DeviceModelSelectFieldFilter = ({
  deviceModelId, allowedTypes, deviceModels, onChange,
}) => {
  // Sort and filter device models
  const sortedDeviceModels = _filter(mDeviceModel.sortElements(deviceModels.elements), ({ type, productible }) => (
    productible && _includes(allowedTypes, type)
  ));

  return (
    <ResourceSelectFieldFilter
      labelId="field.deviceModel"
      resourceId={deviceModelId}
      resources={sortedDeviceModels}
      displayKey="name"
      onChange={onChange}
    />
  );
};

DeviceModelSelectFieldFilter.propTypes = {
  allowedTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  deviceModels: deviceModelsShape.isRequired,
  onChange: PropTypes.func.isRequired,
  // From `connect` HOC
  deviceModelId: PropTypes.number,
};

DeviceModelSelectFieldFilter.defaultProps = {
  deviceModelId: null,
};

const mapStateToProps = (state) => ({
  deviceModels: state.deviceModel.list,
});

module.exports = connect(
  mapStateToProps,
  null,
)(DeviceModelSelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/deviceModels/assets/main/DeviceModelSelectFieldFilter.js